<template>
  <a-card :bordered="false">
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="12">
            <a-form-item label="编号" >
              <a-input disabled v-decorator="['code', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" allow-clear/>
            </a-form-item>
            <a-form-item label="名称">
              <a-input v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" allow-clear/>
            </a-form-item>
            <a-form-item label="姓名">
              <a-input v-decorator="['sender_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="电话">
              <a-input v-decorator="['send_mobile', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" allow-clear/>
            </a-form-item>
            <a-form-item label="位置" >
              <a-input v-decorator="['location', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" allow-clear/>
              <a-select
                v-if="false"
                v-decorator="[
                  'location',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="选择"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.CorporationLocation">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="商品类型" >
              <a-select
                v-decorator="[
                  'goods_type',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="选择"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.GoodsType">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="面积(平方米)" v-if="false">
              <a-input v-decorator="['area', {rules: [{required: true, message: '必填项，请填写信息'}]}]" allow-clear/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item
          v-bind="buttonCol"
        >
          <a-row>
            <a-col :span="8"></a-col>
            <a-col :span="6">
              <a-button type="primary" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col :span="6" :offset="1">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import { warehouse_update, warehouse_list } from '@/api/c_wms_warehouse'
// 表单字段
const fields = ['id', 'name', 'code', 'send_mobile', 'location', 'goods_type', 'sender_name']
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      formLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 7 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 13 }
        }
      },
      form: this.$form.createForm(this),
      loading: false,
      id: 0,
      location: '',
      wms_warehouses: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      fields.forEach(v => this.form.getFieldDecorator(v))
      this.loading = true
      warehouse_list({ id: this.$route.params.id })
        .then(({ data }) => {
          const entries = data.entries
          if (entries && entries.length > 0) {
            this.loadEditInfo(entries[0])
          }
        }).finally(() => {
          this.loading = false
      })
    })
  },
  methods: {
    handleGoBack () {
      this.$router.go(-1)
    },
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('values:', values)
          warehouse_update(values, this.id).then((res) => {
            this.handleGoBack()
          })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, fields)
        this.id = formData.id
        formData.goods_type = data.goods_type.toString()
        form.setFieldsValue(formData)
      })
    }
  }
}
</script>
